import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async';
import { useHistory } from 'react-router-dom';

import { LuArrowLeft, LuArrowUp, LuArrowUpRight } from 'react-icons/lu';

import Reveal from './Reveal';
import PROJECTS from './Projects_data';

import './Project.scss'

const Project = () => {
    const history = useHistory();
    const projects = PROJECTS;
    const [projectData, setProjectData] = useState();
    const id = window.location.pathname.split('/')[2]

    useEffect(() => {
        window.scrollTo(0, 0);
        const project = projects.find(project => project.id === id);
        setProjectData(project);
    }, [id, projects])

    const goBack = () => {
        if (window.history.length > 1) {
            history.goBack();
            return;
        }
        history.push('/');
    };

    return (
        <div className='project-page'>
            {projectData && (
                <Helmet>
                    <title>{projectData.title} | Isuru Ariyarathna</title>
                    <meta name="description" content={projectData.description} />
                    <meta property="og:title" content={`${projectData.title} | Isuru Ariyarathna`} />
                    <meta property="og:description" content={projectData.description} />
                    <meta property="og:image" content={projectData.images[0]} />
                    <meta property="og:url" content={`https://isuruariyarathna.me/projects/${projectData.id}`} />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={`${projectData.title} | Isuru Ariyarathna`} />
                    <meta name="twitter:description" content={projectData.description} />
                    <meta name="twitter:image" content={projectData.images[0]} />
                    <link rel="canonical" href={`https://isuruariyarathna.me/projects/${projectData.id}`} />
                </Helmet>
            )}

            <div className='project-backdrop'>
                <span className='orb'></span>
                <span className='grid'></span>
            </div>

            <div className='page project-hero'>
                <button type='button' className='back-link' onClick={goBack}>
                    <LuArrowLeft /> Back to work
                </button>

                <Reveal className='project-heading'>
                    <span className='project-type'>{projectData?.type}</span>
                    <h1>{projectData?.title}</h1>
                </Reveal>

                <Reveal className='project-meta' delay={80}>
                    <div className='meta-item'>
                        <small>Client</small>
                        <span>{projectData?.client || '-'}</span>
                    </div>

                    {projectData?.country && (
                        <div className='meta-item'>
                            <small>Location</small>
                            <span className='with-flag'>
                                <img src={projectData?.countryFlag} alt={projectData?.country} />
                                {projectData?.country}
                            </span>
                        </div>
                    )}

                    {projectData?.date && (
                        <div className='meta-item'>
                            <small>Year</small>
                            <span>{projectData.date}</span>
                        </div>
                    )}

                    {projectData?.url && (
                        <a className='meta-item meta-link' href={projectData.url} target='_blank' rel='noreferrer'>
                            <small>Live</small>
                            <span>Visit project <LuArrowUpRight /></span>
                        </a>
                    )}
                </Reveal>
            </div>

            <div className='page project-body'>
                <Reveal className='project-overview'>
                    <h2>Overview</h2>
                    <p>{projectData?.description}</p>
                </Reveal>

                <Reveal className='project-stack' delay={80}>
                    <h2>Tech stack</h2>
                    <div className='stack-chips'>
                        {projectData?.technologies.map((tech, index) => (
                            <span key={index}>{tech}</span>
                        ))}
                    </div>
                </Reveal>
            </div>

            <div className='page project-gallery'>
                {projectData?.images.map((image, index) => (
                    <Reveal key={index} variant='scale' className='gallery-item'>
                        <img src={image} alt={projectData.title} loading='lazy' />
                    </Reveal>
                ))}
            </div>

            <footer className='site-footer'>
                <div className='page'>
                    <div className='footer-bottom'>
                        <p>© {new Date().getFullYear()} Isuru Ariyarathna. All rights reserved.</p>
                        <button
                            className='to-top'
                            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                            aria-label='Back to top'
                        >
                            Back to top <LuArrowUp />
                        </button>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default Project
